import { useContext, useEffect } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import AppContext from '@/context/AppContext'
import services from '@/services/services'

import { availableGroupActions } from './constants'

const useReturnGroup = ({ setToastInfo, getDeliveryMethods }) => {
  const { loading, fetchData: assignReturnToGroup } = useFetch(services.assignReturnToGroup, {
    doInitialRequest: false,
  })
  const { context, setContext } = useContext(AppContext)

  useEffect(() => {
    if (
      context?.merchantInfo?.preferences?.allows_multi_order_returns &&
      context?.orderInfo?.return_group &&
      !context?.orderInfo?.availableGroupAction
    ) {
      setContext(context => ({
        ...context,
        orderInfo: { ...context.orderInfo, availableGroupAction: availableGroupActions.out },
      }))
    }
  }, [
    context?.merchantInfo?.preferences?.allows_multi_order_returns,
    context?.orderInfo?.availableGroupAction,
    context?.orderInfo?.return_group,
    setContext,
  ])

  const handleReturnGroup = async inGroup => {
    try {
      await assignReturnToGroup({
        orderId: context?.orderInfo?.id,
        returnId: context?.orderInfo?.returnId,
        inGroup,
      })
      const data = await getDeliveryMethods({
        orderId: context?.orderInfo?.id,
        returnId: context?.orderInfo?.returnId,
        regionId:
          context?.orderInfo?.shipping_address?.province?.id ||
          context?.orderInfo?.shipping_address?.country?.region_id,
      })
      setContext(context => ({
        ...context,
        deliveryMethods: data,
      }))

      setContext(context => ({
        ...context,
        orderInfo: {
          ...context.orderInfo,
          availableGroupAction: inGroup ? availableGroupActions.out : availableGroupActions.in,
        },
      }))
    } catch (error) {
      setToastInfo({ show: true, message: error.errorMessage, type: 'error' })
    }
  }

  const leaveReturnGroup = () => handleReturnGroup(false)

  const joinReturnGroup = () => handleReturnGroup(true)

  const isCombiningReturns = context?.orderInfo?.availableGroupAction === availableGroupActions.in

  return {
    loading,
    leaveReturnGroup,
    availableGroupAction: context.orderInfo.availableGroupAction,
    joinReturnGroup,
    isCombiningReturns,
  }
}

export default useReturnGroup
